<script type="text/ecmascript-6">
import GeneralMixin from "JS/mixins/campaign/general";
import SocialShareMixin from "JS/mixins/campaign/social-share";

export default {
  name: "Footer",
  mixins: [GeneralMixin, SocialShareMixin],
  props: {
    advancedAccessibility: {
      type: Boolean,
      default: false
    },
    andLabel: {
      type: String,
      required: true
    },
    copyright: {
      type: String,
      required: true
    },
    hidePrivacyPolicy: {
      type: Number,
      required: true
    },
    privacyPolicyLabel: {
      type: String,
      required: true
    },
    privacyPolicyUrl: {
      type: String,
      default: ""
    },
    privacyPolicyUrlLabel: {
      type: String,
      default: ""
    },
    subjectTo: {
      type: String,
      required: true
    }
  },
  computed: {
    hasCustomPrivacyText() {
      return !!(this.privacyPolicyUrl && this.privacyPolicyUrlLabel);
    },
    socialShareTag() {
      return this.advancedAccessibility ? "h3" : "p";
    }
  }
};
</script>
